/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {translate} from '@ion/core/src/locale/locale';
import {
  Account,
  Asset,
  CTCEntityResponseWrapper,
  EntityStatus,
  GenericObject
} from '@ion/core/src/types/entities';
import {fromCSV} from '@ion/core/src/utils/CSVUtils';
import {toDateISOString, xlsxDatetoISOString} from '@ion/core/src/utils/DateUtil';
import {convertStatus} from '@ion/dls/src/utils/ComponentUtils';
import {importAssets} from '../../../store/actions/importer';
import {toggleUserPrompt} from '../../../store/actions/user-prompt';

// defines the prop definitions for import start ...
export interface ImportStartType {
  items: Asset[] | GenericObject;
  account?: Account;
  dispatch?: Function;
}

/**
 * Import process starts after validated Excel
 */
export function onImportStart({
  items,
  account,
  dispatch
}: ImportStartType) {
  const assets = augmentItems(items, account);
  if (items?.length) {
    dispatch(importAssets(assets));
  } else {
    dispatch(toggleUserPrompt({message: translate('admin-assets:import.errors.noAssets')}));
  }
}

/**
 * Augments the imported items with additional inferred Asset
 * attributes required by CTC Services.
 */
const augmentItems = (items: Asset[] | GenericObject, account: Account): CTCEntityResponseWrapper<Asset>[] => {
  const assets = [];
  items.forEach((item) => {
    const {
      id,
      status,
      installDate,
      uninstallDate,
      odometerReferenceTime,
      engineHoursReferenceTime,
      associateDeviceEsn,
      associateDeviceName,
      licenseNumber,
      year,
      vin
    } = item;
    item.year                     = year?.toString();
    item.vin                      = vin?.toString();
    item.licenseNumber            = licenseNumber?.toString();
    item.status                   = convertStatus(status);
    item.installDate              = toDateISOString(installDate);
    item.uninstallDate            = toDateISOString(uninstallDate);
    item.odometerReferenceTime    = xlsxDatetoISOString(odometerReferenceTime);
    item.engineHoursReferenceTime = xlsxDatetoISOString(engineHoursReferenceTime);
    item.associateDeviceEsn       = associateDeviceEsn ? fromCSV(associateDeviceEsn?.toString()) : [];
    item.associateDeviceName      = associateDeviceName ? fromCSV(associateDeviceName?.toString()) : [];
    item.id ||= null;
    item.status ||= EntityStatus.Enabled;
    assets.push({asset: item});
  });
  return assets;
};
